import Handlebars from "handlebars";

(() => {
  const linkTemplate = Handlebars.compile(`
    {{~#if link.url~}}
      <a href="{{link.url}}" class="{{ linkClass }} {{#if link.style}}{{ link.style }}{{else}}{{defaultStyle}}{{/if}}" {{#if link.target}}target="{{ link.target }}"{{/if}}>
        {{#if spanClass}}<span class="{{ spanClass }}">{{/if}}
          {{{link.text}}}
        {{#if spanClass}}</span>{{/if}}
      </a>
    {{~else~}}
      {{{link.text}}}
    {{~/if~}}
  `);

  Handlebars.registerHelper("linkTool", (link, options) => {
    const { linkClass, spanClass, defaultStyle = "default-style" } = options.hash ?? {};
    let output = "";

    if (link && link.text) {
      output = linkTemplate({ link, defaultStyle, linkClass, spanClass });
    }

    return new Handlebars.SafeString(output);
  });

  // Translates legacy link.style values to <sp-button> variant names.
  const LEGACY_STYLE_TO_VARIANT = {
    "": "appearance-link",
    "mini-button": "flat",
    "bordered-button": "outlined",
    "translucent-button": "text",
  };

  Handlebars.registerHelper("legacyLinkVariant", (style) => {
    const key = style ?? "";
    return key in LEGACY_STYLE_TO_VARIANT ? LEGACY_STYLE_TO_VARIANT[key] : key;
  });
})();
